import { type StackPacksFilter, StackPacksFilterStatus } from "./StackPacksIndexTypes";

export interface StackPacksIndexState {
	filter: StackPacksFilter;
}

export const initialStackPacksIndexState: StackPacksIndexState = {
	filter: {
		categories: undefined,
		status: StackPacksFilterStatus.AVAILABLE,
	},
};
